import { useCallback, useEffect, useState } from "react";

import campaignService from "core/services/apiServices/campaignService";

const useAffiliates = campaignId => {

    const [ loading, setLoading ] = useState(false);

    const [ affiliates, setAffiliates ] = useState([]);

    const getAffiliates = useCallback( () => {
        setLoading(true);
        let params = {
            campaignId
        };

        campaignService.getAffiliates(params).
            then(data => {
                setAffiliates(data);                
            }).
            finally(() => {
                setLoading(false)
            })
    }, [campaignId])

    const addAffiliates = useCallback(affiliates  => {

        setAffiliates(prevState => ([
            ...affiliates,
            ...prevState
        ]))
    }, [campaignId])

    const removeAffiliate = useCallback( id => {
        setAffiliates(prevState => (
            prevState.filter(l => l.id !== id)
        ))
    }, [campaignId])

    useEffect(() => {
        getAffiliates()
    }, [ campaignId])


    return {
        loading,
        affiliates,
        getAffiliates,
        addAffiliates,
        removeAffiliate,
    }
}

export default useAffiliates;